import { createContext, useCallback, useContext, useEffect, useState } from 'react';

const PresentacionClienteContext = createContext(null);

/** @typedef {{ canal: string, propiedadId: string }} PresentacionSesion */

export function PresentacionClienteProvider({ children }) {
  /** @type {[PresentacionSesion | null, React.Dispatch<React.SetStateAction<PresentacionSesion | null>>]} */
  const [sesion, setSesion] = useState(null);

  const abrirMando = useCallback((detail) => {
    if (detail?.canal && detail?.propiedadId) {
      setSesion({ canal: detail.canal, propiedadId: detail.propiedadId });
    }
  }, []);

  const cerrarMando = useCallback(() => setSesion(null), []);

  useEffect(() => {
    const onStart = (e) => {
      const d = e.detail;
      if (d?.canal && d?.propiedadId) abrirMando(d);
    };
    window.addEventListener('vitalcasa-presentacion-mando', onStart);
    return () => window.removeEventListener('vitalcasa-presentacion-mando', onStart);
  }, [abrirMando]);

  const value = { sesion, abrirMando, cerrarMando };
  return (
    <PresentacionClienteContext.Provider value={value}>{children}</PresentacionClienteContext.Provider>
  );
}

export function usePresentacionCliente() {
  const ctx = useContext(PresentacionClienteContext);
  if (!ctx) {
    throw new Error('usePresentacionCliente debe usarse dentro de PresentacionClienteProvider');
  }
  return ctx;
}
